import { defineStore } from "pinia";
import Api from "@/helpers/api";
import { loading, closeLoding } from "@/helpers/$vs.js";

export const useConnStore = defineStore("connStore", {
  state: () => ({
    nameTables: [],
    records: [],
    titleTable: '',
    connectionID: null,
    tableSelected: '',
    activeSidebarRecords: false,
    HEADERS: [],
    DATA: []
  }),
  actions: {
      async getTables(connectionID, nameTable) {          
        try {          
            loading()
            const result = await Api.post(`/connections/meta`, {connectionID});
            this.titleTable = nameTable;
            this.nameTables = result.data.map(table => table.name);
            this.connectionID = connectionID;
            return true;            
        } catch (error) {
            this.nameTables = [];
            this.titleTable = '';
            this.tableSelected = '';
            this.activeSidebarRecords = false;
            console.log("Error: getTables ", error);
            return false;
        }finally { closeLoding() }   
      },
      async getRecords(connectionID, tableName) {
        try {      
            loading()    
            const result = await Api.post(`/connections/meta`, {connectionID, tableName});           
            this.records = result.data;
            this.tableSelected = tableName;
            this.activeSidebarRecords = true;
            if(result.data[0]) this.getHeaders(result.data[0])            
            return true;            
        } catch (error) {
            this.records = [];
            this.tableSelected = '';
            this.activeSidebarRecords = false;
            console.log("Error: getRecords ", error);
            return false;
        }finally { closeLoding() }   
      },
      async createOrigen(description) {
        try {
          loading()
          const data = {
            connectionID: this.connectionID,
            tableName: this.tableSelected,
            description: description
          }
          await Api.post(`/origins/external`, data);
          return true;
        } catch (error) {
          console.log("Error: createOrige ", error);
          return false;
        }finally { closeLoding() }
      },
      getHeaders(data) {
        this.HEADERS = Object.keys(data);
      }
  }
});
